<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

    <div v-if="value">
      <div class="columns is-multiline">

        <!-- 내부 플러그인 관리 -->
        <div class="column is-8">
          <div class="box">
            <div class="column is-full">
              <admin-form-item label="적립금 사용 설정">
                <lp-radio :val.sync="value.enable"
                          value_name="value"
                          label_name="label"
                          :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
              </admin-form-item>
            </div>
          </div>

          <div class="box" v-if="value.enable">
            <admin-box-item title="적립률 설정" desc="적립금은 구매 확정 시 지급합니다.">
              <div class="column is-full">
                <admin-form-item>
                  <lp-radio :val.sync="value.point_type"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'기본 적립률', value:0}, {label:'결제 방식에 따라 차등 지급', value:1}]"></lp-radio>
                </admin-form-item>

                <!-- 기본 적립률 -->
                <div class="flex align-center"
                     style="margin-bottom:12px"
                     v-if="value.point_type===0">
                  <span>상품 금액의</span>
                  <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.base_rate"
                           @input="e => setFloat(e, 'base_rate', 4)"
                           type="number"
                           v-if="value.base_type===0">
                    <input class="input full has-text-right"
                           v-model="value.base_price"
                           @input="e => setNumber(e, 'base_price', 10)"
                           type="number"
                           v-if="value.base_type===1">
                  </span>
                  <span class="select">
                    <select v-model="value.base_type"
                            @change="e => value.base_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                </div>

                <!-- 결제 방식에 따라 차등 지급 -->
                <div v-if="value.point_type===1">
                  <div class="flex align-center"
                       style="margin-bottom:12px">
                    <span style="width:110px">가상계좌</span>
                    <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.vbank_rate"
                           @input="e => setFloat(e, 'vbank_rate', 4)"
                           step="0.1"
                           type="number"
                           v-if="value.vbank_type===0">
                    <input class="input full has-text-right"
                           v-model="value.vbank_price"
                           @input="e => setNumber(e, 'vbank_price', 10)"
                           type="number"
                           v-if="value.vbank_type===1">
                  </span>
                    <span class="select">
                    <select v-model="value.vbank_type"
                            @change="e => value.vbank_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  </div>

                  <div class="flex align-center"
                       style="margin-bottom:12px">
                    <span style="width:110px">카드 결제</span>
                    <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.card_rate"
                           @input="e => setFloat(e, 'card_rate', 4)"
                           step="0.1"
                           type="number"
                           v-if="value.card_type===0">
                    <input class="input full has-text-right"
                           v-model="value.card_price"
                           @input="e => setNumber(e, 'card_price', 10)"
                           type="number"
                           v-if="value.card_type===1">
                  </span>
                    <span class="select">
                    <select v-model="value.card_type"
                            @change="e => value.card_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  </div>

                  <div class="flex align-center"
                       style="margin-bottom:12px">
                    <span style="width:110px">휴대폰 결제</span>
                    <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.phone_rate"
                           @input="e => setFloat(e, 'phone_rate', 4)"
                           type="number"
                           step="0.1"
                           v-if="value.phone_type===0">
                    <input class="input full has-text-right"
                           v-model="value.phone_price"
                           @input="e => setNumber(e, 'phone_price', 10)"
                           type="number"
                           v-if="value.phone_type===1">
                  </span>
                    <span class="select">
                    <select v-model="value.phone_type"
                            @change="e => value.phone_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  </div>

                  <div class="flex align-center"
                       style="margin-bottom:12px">
                    <span style="width:110px">실시간 계좌 이체</span>
                    <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.trans_rate"
                           @input="e => setFloat(e, 'trans_rate', 4)"
                           step="0.1"
                           type="number"
                           v-if="value.trans_type===0">
                    <input class="input full has-text-right"
                           v-model="value.trans_price"
                           @input="e => setNumber(e, 'trans_price', 10)"
                           type="number"
                           v-if="value.trans_type===1">
                  </span>
                    <span class="select">
                    <select v-model="value.trans_type"
                            @change="e => value.trans_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  </div>
                </div>
              </div>
            </admin-box-item>
          </div>

          <div class="box" v-if="value.enable">
            <admin-box-item title="적립금 사용 제한 설정">
              <div>
                <lp-check-bool :checked-val.sync="value.enable_order"
                               label="상품 주문 금액 조건 설정"></lp-check-bool>
              </div>
              <div class="flex align-center" style="margin-bottom:12px" v-if="value.enable_order">
                <span>상품 주문 합계액 최소</span>
                <span style="margin:0 4px"><input class="input full has-text-right"
                                                  v-model="value.order_price"
                                                  @input="e => setNumber(e, 'order_price', 10)"
                                                  type="number"></span>
                <span>원 이상일 때 사용 가능</span>
              </div>
              <div>
                <lp-check-bool :checked-val.sync="value.enable_accumulation"
                               label="누적 적립금 조건 설정"></lp-check-bool>
              </div>
              <div class="flex align-center" v-if="value.enable_accumulation">
                <span>누적된 적립금이 최소</span>
                <span style="margin:0 4px"><input class="input full has-text-right"
                                                  v-model="value.accumulation_price"
                                                  @input="e => setNumber(e, 'accumulation_price', 10)"
                                                  type="number"></span>
                <span>원 이상일 때 사용 가능</span>
              </div>
            </admin-box-item>
          </div>

          <div class="box" v-if="value.enable">
            <admin-box-item title="특별 적립금 설정">
              <div>
                <lp-check-bool :checked-val.sync="value.enable_sign"
                               label="신규 가입시 조건 설정"></lp-check-bool>
              </div>
              <div class="flex align-center" v-if="value.enable_sign">
                <span>신규 회원 가입 시</span>
                <span style="margin:0 4px"><input class="input full has-text-right"
                                                  v-model="value.sign_price"
                                                  @input="e => setNumber(e, 'sign_price', 10)"
                                                  type="number"></span>
                <span>원 적립</span>
              </div>
            </admin-box-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";
  import AdminFormItem from "../../../module/admin/AdminFormItem";
  import LpCheckBool from "../../../module/common/LpCheckBool";

  export default {
    name: 'point-setting',
    components: {
      LpCheckBool,
      AdminFormItem,
      LpRadio},
    data() {
      return {
        value: undefined,
      }
    },
    created() {
      this.$axios.get('admin/point/setting').then(res=>{
        this.value = res.data;
      })
    },
    methods: {
      // 인풋 숫자 입력시 max_length 조건에 맞춰서 return
      setFloat(e, attr, max_length){
        let max = 100;
        let min = 0;
        let val = parseFloat(e.target.value.substr(0,max_length));
        if(max<val) val = max;
        if(val<min) val= min;
        this.value[attr] =  val;
      },
      setNumber(e, attr, max_length){
        this.value[attr] = parseInt(e.target.value.substr(0,max_length));
      },
      save() {
        this.$axios.patch('admin/point/setting', {
          point_setting: this.value
        }).then(res=>{
          if(res.status===200) this.toast('저장되었습니다.');
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
Z
